export default class LocationFaqs extends HTMLElement {
  constructor() {
    super();
    this.faqs = [];
    this.uniqueId = "faqs-" + Math.random().toString(36).substring(2, 9);
    this.show = false;
  }

  connectedCallback() {
    this.faqs = JSON.parse(this.getAttribute("faqs"));
    this.render();
  }

  updatedCallback() {}

  render() {
    this.innerHTML = "";
    const container = document.createElement("div");

    container.innerHTML = `
    <div class="max-w-7xl mx-auto">
        <h3 class="text-center w-full py-2 md:py-4">
            <button id="${
              this.uniqueId
            }-btn" class="w-full py-4 outline-none focus:outline-none text-2xl" aria-describedby="Read Faqs">
                READ <span class="font-semibold">FAQs</span> <i id="${
                  this.uniqueId
                }-icon" class="venue__faq--icon"></i>
            </button>
        </h3>
        <div id="${
          this.uniqueId
        }-container" class="flex flex-wrap transition delay-300 duration-300 ease-in-out transform transition-all h-0 hidden">
        ${
          this.faqs.length > 0
            ? this.faqs
                .sort((a, b) => {
                  if (a.order < b.order) return -1;
                  if (a.order > b.order) return 1;
                  else return 0;
                })
                .map((faq) => {
                  return ` 
                    <div class="w-full md:w-1/2 h-auto md:h-60 min-h-full p-2 md:p-4 mb-4 md:mb-0 venue__faq">
                      <h4 class="text-2xl font-semibold mb-0 md:mb-2">
                        ${faq.question}
                      </h4>
                      <div>${faq.answer}</div>
                    </div>
                    `;
                })
                .join("")
            : null
        }
        </div>
    </div>
    `;

    this.appendChild(container);
    this._addEventListeners();
  }

  _addEventListeners() {
    const btn = this.querySelector(`#${this.uniqueId}-btn`);
    if (btn) {
      const faqsContainer = this.querySelector(`#${this.uniqueId}-container`);
      const icon = this.querySelector(`#${this.uniqueId}-icon`);
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        // this.show = !this.show;
        faqsContainer.classList.toggle("h-0");
        faqsContainer.classList.toggle("hidden");
        faqsContainer.classList.toggle("h-full");
        icon.classList.toggle("active");
      });
    }
  }

  static get observedAttributes() {
    return ["faqs"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "faqs":
        this.faqs = newValue;
        break;
    }
  }
}
